import { AxiosResponse } from "axios";
import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { timeZoneFilterRequest } from "@/main/models/request/timeZone";

export abstract class ITimeZoneApi {
	abstract getDomain(request: timeZoneFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
